import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Home from "@/pages/Home";
import BookingForm from "@/pages/BookingForm";
import Login from "@/pages/Login";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import HorseFile from "@/pages/HorseFile";
import HorseForm from "@/pages/HorseForm";
import ConsultationDetail from "@/pages/ConsultationDetail";

function Protected({ children, adminOnly }) {
  const { user, loading } = useApp();
  if (loading)
    return <div className="flex min-h-screen items-center justify-center text-muted-foreground">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/customer" replace />;
  return children;
}

function Dashboard() {
  const { user, loading } = useApp();
  if (loading)
    return <div className="flex min-h-screen items-center justify-center text-muted-foreground">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return user.role === "admin" ? <Navigate to="/admin" replace /> : <Navigate to="/customer" replace />;
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/consultation" element={<BookingForm mode="consultation" />} />
            <Route path="/riding-lesson" element={<BookingForm mode="riding_lesson" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customer" element={<Protected><CustomerDashboard /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
            <Route path="/horse/:id" element={<Protected><HorseFile /></Protected>} />
            <Route path="/horse-form" element={<Protected adminOnly><HorseForm /></Protected>} />
            <Route path="/horse-form/:id" element={<Protected adminOnly><HorseForm /></Protected>} />
            <Route path="/consultation/:id" element={<Protected adminOnly><ConsultationDetail /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
